const openWhatsapp = () => {
    window.open('https://amipassmerchants.zendesk.com/hc/es-419')
}

export const formatCurrency = (value, currency = 'CLP') => {
    let finalValue = value
    if (typeof value === 'string') {
        finalValue = parseInt(finalValue)
    } else if (typeof value !== 'number') return ''
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(finalValue)
}

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export function formatCurrentDate() {
    const date = new Date()

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear().toString()

    return `${day}/${month}/${year}`
}

export default openWhatsapp
